import { Component, OnInit } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { authControl, roleLists } from './config/ulit';
import { LangService } from './service/lang.service';
import { NgxSpinnerModule } from "ngx-spinner";
import { HashLocationStrategy, LocationStrategy } from '@angular/common';
import { VersionCheckService } from './service/version-check.service';
@Component({
  selector: 'app-root',
  standalone: true,
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
  imports: [
    RouterOutlet,
    NgxSpinnerModule,
  ],
  providers: [{ provide: LocationStrategy, useClass: HashLocationStrategy }]
})
export class AppComponent implements OnInit {
  title = 'hrms';

  constructor(
    private translateService: TranslateService,
    private langService: LangService,
        private versionCheck: VersionCheckService

    /* private idleTimeoutService: IdleTimeoutService,
    private versionCheck: VersionCheckService */ //Automatic Logout Service
  ) { }

  ngOnInit(): void {
    this.translateService.setDefaultLang(this.langService.defaultLang);
    this.translateService.addLangs(this.langService.supportLanguages);
    //this.versionCheck.initVersionCheck(30000); // check every 30s
    console.log(this.versionCheck, 'versionchk')

    this.setAppLang();

    const userData = JSON.parse(sessionStorage.getItem('userDate')!);

    if (userData && userData.role.name === "Hr Project Admin") {
      roleLists.timeKeeper = userData.role.name;
    }
  }

  setAppLang() {
    const lang = sessionStorage.getItem(authControl.lang);

    if (lang) {
      const htmlTag = document.documentElement;
      htmlTag.setAttribute(
        'dir',
        lang === this.langService.defaultLang ? 'ltr' : 'rtl'
      );
      htmlTag.setAttribute(
        'lang',
        lang === this.langService.defaultLang ? 'en' : 'ar'
      );
      // this.translateService.setDefaultLang(this.langService.defaultLang);
      // this.translateService.addLangs(this.langService.supportLanguages);
      this.translateService.use(lang);


    }


    // this.translateService.use(lang);
  }
}
